/* jshint esversion: 6 */
/* jshint module: true */

export const availableDaysList = (limitDays, dateMax) => {
    const limits = [];
    const oneDayMillSec = 60 * 60 * 24 * 1000;
    const dateMaxUnixTime = Date.parse(dateMax);
    const days = limitDays;
    for (let i = 0; i < days; i++) {
        const dateMillSec = dateMaxUnixTime - oneDayMillSec * i;
        const date = new Date(dateMillSec);
        const output = date.toISOString().substring(0, 10);
        limits[i] = output;
    }
    return limits;
};

export const unavailableDaysList = dates => {
    const date = dates.split(',');
    const list = [];
    date.forEach((element, index) => {
        const dateAr = element.split(' ');
        const dateFinal = `${dateAr[2]}-${dateAr[1]}-${dateAr[0]}`;
        list[index] = dateFinal;
    });
    return list;
};

export const dateMaxRestore = () => {
    const calendar = document.querySelector('#bookAnAppointmentData');
    const oneDayMillSec = 60 * 60 * 24 * 1000;
    const limitDays = calendar.dataset.calendarLimitDays === '0' || calendar.dataset.calendarLimitDays === '' ? 365 : calendar.dataset.calendarLimitDays;
    const startDay = calendar.dataset.dateStart;
    const startDayUnixTime = Date.parse(startDay);
    const dateMaxUnixTime = startDayUnixTime + oneDayMillSec * limitDays;
    const date = new Date(dateMaxUnixTime);
    const dateMax = date.toISOString().substring(0, 10);
    calendar.setAttribute('data-date-max', dateMax);
};

export const isDateAvailable = () => {
    let bookedDays = 0;
    const calendar = document.querySelector('#bookAnAppointmentData');
    const limitDays = calendar.dataset.calendarLimitDays === '0' || calendar.dataset.calendarLimitDays === '' ? 999 : calendar.dataset.calendarLimitDays;
    const dateMaxValue = calendar.dataset.dateMax;
    // use attributes to avoid data cache
    const unavailableDates = calendar.attributes['data-unavailable-dates'] ? calendar.attributes['data-unavailable-dates'].value : null;
    if (unavailableDates) {
        const availableDays = availableDaysList(limitDays, dateMaxValue);
        const unavailableDays = unavailableDaysList(unavailableDates);

        availableDays.forEach(element => {
            // is day unavailable
            if (unavailableDays.includes(element)) {
                bookedDays += 1;
            }
        });
    }
    const isAvailable = bookedDays < limitDays;

    return isAvailable;
};
